import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { PolicyResponse } from '../../models/PolicyResponse';
import { PolicyService } from '../../shared/services/policy.service';
import { ActivatedRoute } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-policy-details',
  imports: [CommonModule, TranslateModule],
  templateUrl: './policy-details.component.html',
  styleUrl: './policy-details.component.scss',
})
export class PolicyDetailsComponent {
  policyDetails: PolicyResponse | undefined;
  isLoading: boolean = true;
  policyId: string = '';

  constructor(private policyService: PolicyService, private route: ActivatedRoute) {}

  ngOnInit(): void {
    this.isLoading = true;
    this.policyId = this.route.snapshot.paramMap.get('id') || '';
    this.fetchPolicyDetails();
  }

  fetchPolicyDetails() {
    this.policyService.getPolicyDetailsById(this.policyId).subscribe({
      next: (response) => {
        this.policyDetails = response;
        this.isLoading = false;
      },
      error: (error) => {
        console.error('Error fetching policy details:', error);
        this.isLoading = false;
      },
    });
  }

  /**
   * Format date array [year, month, day] to readable date string
   * @param dateArray - Array of [year, month, day]
   * @returns Formatted date string
   */
  formatDateArray(dateArray: number[]): string {
    if (!dateArray || dateArray.length < 3) {
      return 'N/A';
    }
    
    try {
      // Note: Month in JavaScript Date is 0-indexed, so subtract 1 from the month
      const date = new Date(dateArray[0], dateArray[1] - 1, dateArray[2]);
      return date.toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      });
    } catch (error) {
      console.error('Error formatting date:', error);
      return 'Invalid Date';
    }
  }

  goBack() {
    window.history.back();
  }
}
